(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-bags"] && !Shopify.designMode) return;
  try {
    function adjustBagTitleHeight() {
    const titles = document.querySelectorAll('.card-bags-ttl')
    console.log('高さ調整中')
    titles.forEach((el) => {
      el.style.minHeight = ''
    })

    for (let i = 0; i < titles.length; i += 2) {
      const left = titles[i]
      const right = titles[i + 1]

      if (!right) continue

      const maxHeight = Math.max(left.offsetHeight, right.offsetHeight)

      left.style.minHeight = maxHeight + 'px'
      right.style.minHeight = maxHeight + 'px'
    }
    document.querySelectorAll('.bag-grid-section').forEach((section) => {
      const cards = section.querySelectorAll('.card')

      cards.forEach((el) => {
        el.style.minHeight = ''
      })

      for (let i = 0; i < cards.length; i += 2) {
        const left = cards[i]
        const right = cards[i + 1]

        if (!right) continue

        const maxHeight = Math.max(left.offsetHeight, right.offsetHeight)

        left.style.minHeight = maxHeight + 'px'
        right.style.minHeight = maxHeight + 'px'
      }
    })
  }

  adjustBagTitleHeight()
  } catch(e) { console.error(e); }
})();

})();
